import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Table from "../../../../components/ACS-Dashboard/ACS-Blocks/Table";
import Loader from "../../../../components/ACS-Dashboard/ACS-Blocks/Loader";
import { MoreHorizontal } from "lucide-react";
import ActionMenu from "../../../../components/ACS-Dashboard/ACS-Blocks/ActionMenu";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { addTab } from "../../../../redux/slices/invoiceSlice";

const TABLE_HEADERS = [
  "Selection",
  "Action",
  "Invoice Number",
  "Message",
  "Status",
  "Location",
  "Phone Number",
  "Start Date",
  "Timestamp"
];

const InvoiceNotificationTable = ({ searchQuery = "", searchTrigger, setTotalNotifications }) => {
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [InoicenotificationsPerPage, setInoicenotificationsPerPage] = useState(10);
  const [openDropdownRow, setOpenDropdownRow] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const dropdownRef = useRef(null);

  const token = Cookies.get("authToken");
  const officeCode = Cookies.get("officeCode");
  const dispatch = useDispatch();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownRow(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Uncomment when endpoint is ready
  // useEffect(() => {
  //   fetchNotifications();
  // }, [searchTrigger, currentPage, notificationsPerPage]);

  // const fetchNotifications = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/api/notifications/invoices?page=${currentPage - 1}&size=${notificationsPerPage}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Office-Code": officeCode,
  //         },
  //       }
  //     );
  //
  //     const { content, totalElements, totalPages } = response.data;
  //     setNotifications(content);
  //     setTotalNotifications(totalElements);
  //     setTotalPages(totalPages);
  //   } catch (error) {
  //     console.error("Error fetching invoice notifications:", error);
  //     setTotalNotifications(0);
  //     setNotifications([]);
  //     setTotalPages(1);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const formattedNotifications = notifications.map((n) => ({
    "Invoice Number": n?.invoiceNumber ?? "-",
    "Message": n?.message ?? "-",
    "Status": n?.status ?? "-",
    "Location": n?.location ?? "-",
    "Phone Number": n?.phoneNumber ?? "-",
    "Start Date": n?.startDate ?? "-",
    "Timestamp": n?.timestamp ?? "-",
  }));

  const handleSelectAll = (checked) => {
    setSelectedNotifications(checked ? formattedNotifications.map(n => n["Invoice Number"]) : []);
  };

  const handleSingleCheckbox = (invoiceNumber) => {
    setSelectedNotifications(prev =>
      prev.includes(invoiceNumber)
        ? prev.filter(id => id !== invoiceNumber)
        : [...prev, invoiceNumber]
    );
  };

  const handleViewInvoice = (invoiceNumber) => {
    const newTabId = `invoice-${invoiceNumber}-${Date.now()}`;
    dispatch(addTab({
      id: newTabId,
      name: `Invoice: ${invoiceNumber}`,
      contentType: "invoiceView",
      invoiceNumber,
      isDynamic: true,
      createdAt: Date.now(),
    }));
  };

  const handleEditInvoice = (invoiceNumber) => {
    console.log("Editing invoice notification:", invoiceNumber);
  };

  const handleDeleteInvoice = (invoiceNumber) => {
    console.log("Deleting invoice notification:", invoiceNumber);
  };

  const handleActionClick = (invoiceNumber, e) => {
    e.stopPropagation();
    setOpenDropdownRow((prev) => (prev === invoiceNumber ? null : invoiceNumber));
  };

  const renderActionColumn = (row) => (
    <td
      onClick={(e) => e.stopPropagation()}
      className={`sticky left-[80px] bg-white border-b border-gray-200 text-center ${
        openDropdownRow === row["Invoice Number"] ? "z-[20]" : "z-[10]"
      }`}
      style={{
        width: "50px",
        minWidth: "50px",
        maxWidth: "50px",
        boxShadow: "2px 0 2px -1px rgba(0,0,0,0.1)",
      }}
    >
      <div className="relative">
        <button
          className="p-1 text-gray-500 hover:text-gray-800 w-full relative z-[1]"
          onClick={(e) => handleActionClick(row["Invoice Number"], e)}
        >
          <MoreHorizontal size={18} className="mx-auto" />
        </button>

        {openDropdownRow === row["Invoice Number"] && (
          <ActionMenu
            rowId={row["Invoice Number"]}
            isOpen={openDropdownRow === row["Invoice Number"]}
            onClose={() => setOpenDropdownRow(null)}
            moduleName="Invoice"
            actions={[
              {
                icon: "Eye",
                label: "View",
                color: "blue",
                action: (id) => handleViewInvoice(id),
              },
              {
                icon: "Edit",
                label: "Edit",
                color: "green",
                action: (id) => handleEditInvoice(id),
              },
              {
                icon: "Trash",
                label: "Delete",
                color: "red",
                action: (id) => handleDeleteInvoice(id),
              },
            ]}
          />
        )}
      </div>
    </td>
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <div className="bg-white flex flex-col h-full">
      {/* {isLoading ? (
        <Loader
          color="text-blue-600"
          size="h-5 w-5"
          message="Loading Invoice Notifications..."
        />
      ) : ( */}
        <>
          <div className="flex-1 min-h-[200px] bg-white sm:min-h-[300px] overflow-x-auto">
            <Table
              headers={TABLE_HEADERS}
              data={formattedNotifications}
              onSelectAll={handleSelectAll}
            >
              {(row) => (
                <>
                  <td
                    className="sticky left-0 bg-white border-b border-gray-200"
                    onDoubleClick={() => handleViewInvoice(row["Invoice Number"])}
                    style={{
                      width: "80px",
                      minWidth: "80px",
                      maxWidth: "80px",
                      boxShadow: "2px 0 2px -1px rgba(0,0,0,0.1)",
                    }}
                  >
                    <input
                      type="checkbox"
                      className="cursor-pointer mx-auto block"
                      checked={selectedNotifications.includes(row["Invoice Number"] || "")}
                      onChange={() => handleSingleCheckbox(row["Invoice Number"])}
                    />
                  </td>

                  {renderActionColumn(row)}

                  {TABLE_HEADERS.slice(2).map((header) => (
                    <td
                      key={header}
                      className="px-2 sm:px-3 py-1 sm:py-2 text-black text-xs sm:text-sm md:text-base border-b border-gray-200"
                      onDoubleClick={() => handleViewInvoice(row["Invoice Number"])}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "200px",
                      }}
                    >
                      {row[header]}
                    </td>
                  ))}
                </>
              )}
            </Table>
          </div>

          {/* Pagination */}
          <div className="flex justify-between border-t items-center bg-white p-fluid-1">
            <div className="flex items-center">
              <span className="mr-2">Notifications per page</span>
              <select
                value={InoicenotificationsPerPage}
                onChange={(e) => {
                  setInoicenotificationsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="border-b-2 border-black focus:outline-none"
              >
                {[5, 10, 25, 50].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-center">
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className="mx-2 text-gray-500 disabled:opacity-50"
              >
                ❮
              </button>
              <span>
                {currentPage} of {totalPages}
              </span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className="mx-2 text-gray-500 disabled:opacity-50"
              >
                ❯
              </button>
            </div>
          </div>
        </>
      {/* )} */}
    </div>
  );
};

export default InvoiceNotificationTable;
